import Vue from 'vue'

Vue.mixin({
  methods: {
    isAppStandalone () {
      try {
        return window.self === window.top;
      } catch (e) {
        return true;
      }
    },
    getShareCode () {
      let m;
      if (m = location.href.match(/share_code=(.+)/)) { // \w+
        return m[1];
      }
    },
    isProduction () {
      return process.env.NODE_ENV == 'production'
    },
    unixToDate: function (unix) {
      return new Date(unix * 1000).toLocaleDateString()
    },
    capitalize: function (word) {
      let firstLetter = word[0].toUpperCase();
      let rtnWord = firstLetter + word.substring(1);
      return rtnWord
    }
  }
});

Vue.directive("click-outside", {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});



// WEBPACK FOOTER //
// ./src/helpers.js